import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { StrategyPage } from './pages/StrategyPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/strategy" element={<StrategyPage data-id="element-7" />} data-id="element-6" />
        <Route path="/team" element={<TeamPage data-id="element-9" />} data-id="element-8" />
        <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}